<template>
  <section
    class="rev-ras-featured-video-carrousel-module-component"
    :style="{
      backgroundColor: data.background_color
        ? data.background_color
        : '#1E6B5C',
    }">
    <div class="outlined-logo">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="970"
        height="1526"
        viewBox="0 0 970 1526"
        fill="none">
        <g opacity="0.3">
          <path
            d="M740.088 603.537L310.652 895.213C302.144 901.1 290.683 901.1 282 895.213L122.59 787.559C101.057 773.093 72.4052 773.093 51.0463 787.559L-146.741 921.959L282.174 1213.3C290.856 1219.19 302.317 1219.19 310.826 1213.3L908.181 807.408C941.521 784.699 961.491 747.693 961.491 708.164V492.014C961.491 456.522 943.605 423.048 913.564 402.695L360.837 28.0912C322.113 1.85046 270.366 1.85046 231.642 28.0912L-320.39 403.367C-350.432 423.721 -368.318 457.026 -368.318 492.687V664.429C-368.318 702.276 -324.211 724.648 -292.085 702.781L282 312.534C290.683 306.647 302.144 306.647 310.652 312.534L739.914 603.705L740.088 603.537Z"
            stroke="#13D377"
            stroke-miterlimit="10" />
          <path
            d="M282 1213.47L-146.914 922.126L282 630.114C290.683 624.227 301.97 624.227 310.652 630.114L477.703 742.815C494.895 754.421 517.816 754.421 535.008 742.815L740.088 603.537L310.826 312.366C302.144 306.478 290.683 306.478 282.174 312.366L-315.007 718.256C-348.348 740.964 -368.318 777.971 -368.318 817.5V1033.31C-368.318 1068.81 -350.432 1102.11 -320.39 1122.46L231.642 1497.74C270.366 1524.15 322.113 1524.15 360.837 1497.74L913.39 1122.3C943.432 1101.94 961.317 1068.64 961.317 1032.98V861.235C961.317 823.219 917.21 801.015 885.085 822.883L310.479 1213.3C301.796 1219.19 290.335 1219.19 281.827 1213.3L282 1213.47Z"
            stroke="#13D377"
            stroke-miterlimit="10" />
        </g>
      </svg>
    </div>

    <div class="rr-container">
      <div
        v-if="data.show_top_content"
        class="top-content">
        <h2 v-html="data.top_content.title"></h2>

        <div class="content">
          <div class="video-container">
            <img
              v-if="posterImageUrl"
              class="video-placeholder"
              :src="posterImageUrl"
              :alt="posterImageAlt" />

            <button
              v-if="vimeoEmbedUrl"
              class="player"
              type="button"
              :aria-label="`Play ${featuredArticleTitle}`"
              @click="openVideoModal">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="34"
                height="39"
                viewBox="0 0 34 39"
                fill="none">
                <path
                  d="M32.2165 16.4084C34.2165 17.5631 34.2166 20.4499 32.2166 21.6046L4.49999 37.6068C2.49999 38.7615 -1.33145e-05 37.3181 -1.32135e-05 35.0087L-1.18146e-05 3.00435C-1.17136e-05 0.694952 2.49999 -0.748427 4.49999 0.406273L32.2165 16.4084Z"
                  fill="white" />
              </svg>
            </button>
          </div>
          <div
            ref="greenBox"
            class="green-box">
            <div class="quote-decor">
              <svg
                class="quote-svg left"
                xmlns="http://www.w3.org/2000/svg"
                width="98"
                height="98"
                viewBox="0 0 98 98"
                fill="none">
                <rect
                  x="98"
                  y="50.0576"
                  width="47.9424"
                  height="98"
                  transform="rotate(90 98 50.0576)"
                  fill="#13D377" />
                <rect
                  x="2.38262e-05"
                  width="47.9424"
                  height="98"
                  fill="#13D377" />
              </svg>

              <svg
                class="quote-svg right"
                xmlns="http://www.w3.org/2000/svg"
                width="98"
                height="98"
                viewBox="0 0 98 98"
                fill="none">
                <rect
                  x="4.28372e-06"
                  y="47.9425"
                  width="47.9424"
                  height="98"
                  transform="rotate(-90 4.28372e-06 47.9425)"
                  fill="#13D377" />
                <rect
                  x="98"
                  y="98.0001"
                  width="47.9424"
                  height="98"
                  transform="rotate(180 98 98.0001)"
                  fill="#13D377" />
              </svg>
            </div>

            <h3 v-html="data.top_content?.article[0]?.post_title"></h3>

            <div class="bottom">
              <div
                class="description"
                v-html="data.top_content?.article[0]?.acf?.description"></div>

              <a
                :href="data.top_content?.article[0]?.permalink"
                target="_self"
                rel="noopener noreferrer"
                :title="data.top_content?.article[0]?.post_title">
                <span>More </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="18"
                  viewBox="0 0 20 18"
                  fill="none">
                  <g clip-path="url(#clip0_298_144)">
                    <path
                      d="M10 17.1563V16.7188L13.6449 13.0625C15.7009 11 16.4797 10.5625 16.6978 10.3125C16.8536 10.1563 16.8536 10.0625 16.8224 9.9375C16.7913 9.8125 16.6667 9.75 16.4797 9.75C16.1059 9.75 14.9844 9.9375 12.3676 9.9375L0.311526 9.9375L0 9.625L0 8.34375L0.311526 8.03125L12.3988 8.03125C15.0156 8.03125 16.1371 8.21875 16.5109 8.21875C16.6978 8.21875 16.8224 8.15625 16.8536 8.03125C16.8847 7.90625 16.8847 7.8125 16.729 7.65625C16.5109 7.4375 15.7321 6.96875 13.676 4.90625L10.0312 1.25V0.812502L10.8723 -0.0312481H11.3084L20 8.6875V9.25L11.3084 18H10.8723L10.0312 17.1563H10Z"
                      fill="#70FFE5" />
                  </g>
                  <defs>
                    <clipPath id="clip0_298_144">
                      <rect
                        width="18"
                        height="20"
                        fill="white"
                        transform="matrix(0 -1 1 0 0 18)" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="data.show_bottom_content"
        class="bottom-content">
        <div class="divider-container">
          <BicolorLine
            :bigger="true"
            left="humble"
            right="progressive" />
        </div>

        <h3>More Videos</h3>

        <div
          v-if="bottomArticles.length"
          class="posts-carousel">
          <Splide
            :options="postsTrackOptions"
            :has-track="false"
            aria-label="Video articles">
            <SplideTrack>
              <SplideSlide
                v-for="article in bottomArticles"
                :key="article?.ID || article?.id || article?.permalink">
                <a
                  class="post-card"
                  :href="articleUrl(article)"
                  :aria-label="plainText(article?.post_title)">
                  <div class="post-image">
                    <img
                      v-if="articleImage(article).url"
                      :src="articleImage(article).url"
                      :alt="articleImage(article).alt || ''" />

                    <span
                      class="post-player"
                      aria-hidden="true">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="34"
                        height="39"
                        viewBox="0 0 34 39"
                        fill="none">
                        <path
                          d="M32.2165 16.4084C34.2165 17.5631 34.2166 20.4499 32.2166 21.6046L4.49999 37.6068C2.49999 38.7615 -1.33145e-05 37.3181 -1.32135e-05 35.0087L-1.18146e-05 3.00435C-1.17136e-05 0.694952 2.49999 -0.748427 4.49999 0.406273L32.2165 16.4084Z"
                          fill="white" />
                      </svg>
                    </span>
                  </div>

                  <h3
                    v-if="article?.post_title"
                    class="post-title"
                    v-html="article.post_title"></h3>
                </a>
              </SplideSlide>
            </SplideTrack>

            <div
              v-if="bottomArticles.length > 2"
              class="splide__arrows">
              <button
                class="splide__arrow splide__arrow--prev rotate-180"
                type="button"
                aria-label="Previous articles">
                <span class="navigation-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none">
                    <path
                      d="M24.9023 12L12.9023 24L11.2256 22.3232L20.3633 13.1855L-1.15272e-06 13.1855L-9.45344e-07 10.8135L20.3623 10.8135L11.2256 1.67676L12.9023 1.12796e-06L24.9023 12Z" />
                  </svg>
                </span>
              </button>
              <button
                class="splide__arrow splide__arrow--next"
                type="button"
                aria-label="Next articles">
                <span class="navigation-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none">
                    <path
                      d="M24.9023 12L12.9023 24L11.2256 22.3232L20.3633 13.1855L-1.15272e-06 13.1855L-9.45344e-07 10.8135L20.3623 10.8135L11.2256 1.67676L12.9023 1.12796e-06L24.9023 12Z" />
                  </svg>
                </span>
              </button>
            </div>
          </Splide>
        </div>
      </div>
    </div>
  </section>

  <Teleport to="body">
    <Transition name="featured-video-modal-fade">
      <div
        v-if="videoModalOpen"
        class="featured-video-modal"
        role="dialog"
        aria-modal="true"
        :aria-label="featuredArticleTitle"
        @click.self="closeVideoModal">
        <div class="featured-video-modal-content">
          <button
            ref="modalCloseRef"
            class="featured-video-modal-close"
            type="button"
            aria-label="Close video"
            @click="closeVideoModal">
            <span></span>
            <span></span>
          </button>

          <iframe
            :src="vimeoEmbedUrl"
            :title="featuredArticleTitle"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowfullscreen></iframe>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
/* #META
 {
  "NAME": "RevRASFeaturedVideoCarrouselComponent",
  "CLASSNAME": "rev-ras-featured-video-carrousel-module-component",
  "URL": "http://vuevitewp.local/test"
 }
#ENDMETA */

/*
 * Insert your logic here
 */
import useSmoothScroll from '@/components/composables/useSmoothScroll'
import BicolorLine from '@/components/utility/BicolorLine.vue'
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide'
import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import '@splidejs/vue-splide/css/core'

const props = defineProps(['data'])
const modalCloseRef = ref(null)
const greenBox = ref(null)
const videoModalOpen = ref(false)
let previousBodyOverflow = ''
let greenBoxResizeObserver = null
const { locoScroll } = useSmoothScroll()

console.log(props.data, 'data')

const featuredArticle = computed(
  () => props.data?.top_content?.article?.[0] || null
)

const featuredArticleAcf = computed(() => featuredArticle.value?.acf || {})

const featuredArticleTitle = computed(() => {
  const title = featuredArticle.value?.post_title || 'Featured video'
  return String(title).replace(/<[^>]*>/g, '')
})

const imageValue = (snakeCaseKey, camelCaseKey) =>
  featuredArticleAcf.value?.[snakeCaseKey] ||
  featuredArticleAcf.value?.[camelCaseKey] ||
  {}

const posterImage = computed(() => {
  const placeholder = imageValue('video_placeholder', 'videoPlaceholder')
  if (placeholder?.url) return placeholder

  return imageValue('carrousel_image', 'carrouselImage')
})

const posterImageUrl = computed(() => posterImage.value?.url || '')
const posterImageAlt = computed(
  () => posterImage.value?.alt || featuredArticleTitle.value
)

const vimeoUrl = computed(
  () =>
    featuredArticleAcf.value?.vimeo_url ||
    featuredArticleAcf.value?.vimeoUrl ||
    ''
)

const normalizeArticle = (article) => ({
  ...article,
  post_title: article?.post_title || article?.title?.rendered || '',
  permalink: article?.permalink || article?.post_url || article?.link || '',
})

const bottomArticles = computed(() => {
  const articles = props.data?.bottom_content?.articles
  return Array.isArray(articles) ? articles.map(normalizeArticle) : []
})

const articleImage = (article) => {
  const acf = article?.acf || {}

  return (
    acf.carrousel_image ||
    acf.carrouselImage ||
    acf.video_placeholder ||
    acf.videoPlaceholder ||
    {}
  )
}

const articleUrl = (article) =>
  article?.permalink || article?.post_url || article?.link || '#'

const plainText = (value) => String(value || '').replace(/<[^>]*>/g, '')

const postsTrackOptions = computed(() => ({
  rewind: false,
  perPage: 3,
  perMove: 1,
  focus: 0,
  trimSpace: true,
  speed: 500,
  pagination: false,
  arrows: bottomArticles.value.length > 2,
  type: bottomArticles.value.length > 2 ? 'loop' : 'slide',
  autoplay: false,
  gap: '38px',
  breakpoints: {
    1023: {
      perPage: 2,
      gap: '24px',
    },
    767: {
      perPage: 1.15,
      gap: '16px',
    },
  },
}))

const getVimeoId = (url) => {
  if (!url) return ''

  const cleaned = String(url).trim()
  const idMatch = cleaned.match(/(?:vimeo\.com\/(?:video\/)?)(\d+)/)

  if (idMatch?.[1]) return idMatch[1]
  if (/^\d+$/.test(cleaned)) return cleaned

  return ''
}

const vimeoEmbedUrl = computed(() => {
  const vimeoId = getVimeoId(vimeoUrl.value)
  if (!vimeoId) return ''

  return `https://player.vimeo.com/video/${vimeoId}?autoplay=1&controls=1&muted=0&playsinline=1&title=0&byline=0&portrait=0&dnt=1`
})

const openVideoModal = () => {
  if (!vimeoEmbedUrl.value) return

  videoModalOpen.value = true
  nextTick(() => modalCloseRef.value?.focus())
}

const closeVideoModal = () => {
  videoModalOpen.value = false
}

const handleKeydown = (event) => {
  if (event.key === 'Escape' && videoModalOpen.value) closeVideoModal()
}

const updateGreenBoxOverlap = () => {
  if (!greenBox.value) return

  const overlap = Math.round(
    greenBox.value.getBoundingClientRect().height - 148
  )
  const overlapValue = `${overlap}px`

  if (
    greenBox.value.style.getPropertyValue('--green-box-overlap') ===
    overlapValue
  ) {
    return
  }

  greenBox.value.style.setProperty('--green-box-overlap', overlapValue)
  locoScroll.value?.resize?.()
}

watch(videoModalOpen, (open) => {
  if (open) {
    previousBodyOverflow = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    locoScroll.value?.stop?.()
    return
  }

  document.body.style.overflow = previousBodyOverflow
  locoScroll.value?.start?.()
})

onMounted(() => {
  window.addEventListener('keydown', handleKeydown)

  greenBoxResizeObserver = new ResizeObserver(updateGreenBoxOverlap)

  if (greenBox.value) {
    greenBoxResizeObserver.observe(greenBox.value)
    updateGreenBoxOverlap()
  }
})

onBeforeUnmount(() => {
  window.removeEventListener('keydown', handleKeydown)
  greenBoxResizeObserver?.disconnect()
  document.body.style.overflow = previousBodyOverflow
  locoScroll.value?.start?.()
})
</script>

<style lang="scss" scoped>
.rev-ras-featured-video-carrousel-module-component {
  @apply relative py-20 lg:py-[90px];

  &:before {
    @apply absolute bg-white top-0 left-0 w-full h-full pointer-events-none;
    content: '';

    @apply rounded-tr-[50px] md:rounded-tr-[60px] lg:rounded-tr-[80px];
  }

  .outlined-logo {
    @apply absolute inset-0 left-[-5%] w-full h-full pointer-events-none;
  }

  h2 {
    @apply header-2 text-balanced mb-6;
  }

  .top-content {
    .content {
      @apply flex flex-col gap-8 lg:gap-0;

      .video-container {
        @apply relative w-full max-w-[930px] overflow-hidden rounded-[15px];
        aspect-ratio: 16 / 9;

        .video-placeholder {
          @apply absolute inset-0 h-full w-full object-cover object-center;
        }

        .player {
          @apply absolute left-1/2 top-1/2 z-2 flex h-[52px] w-[52px] -translate-x-1/2 -translate-y-1/2 cursor-pointer flex-col items-center justify-center rounded-full border border-white/30 p-0 transition-transform duration-300 lg:h-[122px] lg:w-[122px];
          background: linear-gradient(
              0deg,
              rgba(30, 107, 92, 0.06),
              rgba(30, 107, 92, 0.06)
            ),
            linear-gradient(
              270deg,
              rgba(255, 255, 255, 0.2) 44.96%,
              rgba(255, 255, 255, 0) 58.69%
            ),
            linear-gradient(
              90deg,
              rgba(255, 255, 255, 0.2) 11.27%,
              rgba(255, 255, 255, 0) 23.4%
            ),
            rgba(255, 255, 255, 0.42);
          box-shadow: inset 0 2px 1px rgba(255, 255, 255, 0.15);
          -webkit-backdrop-filter: blur(20px);
          backdrop-filter: blur(20px);

          &:hover,
          &:focus-visible {
            @apply scale-105;
          }

          &:focus-visible {
            outline: 2px solid #13d377;
            outline-offset: 4px;
          }

          svg {
            @apply h-[20px] w-[18px] translate-x-[2px] lg:h-[39px] lg:w-[34px];
          }
        }
      }

      .green-box {
        @apply relative bg-balanced px-5 pt-10 pb-5 lg:px-5 lg:pt-14 lg:pb-6 lg:mr-0 lg:ml-auto;
        @apply lg:w-[391px];
        @apply lg:flex lg:flex-col lg:justify-between;

        @media (min-width: 1024px) {
          transform: translateY(calc(-1 * var(--green-box-overlap, 302px)));
          margin-bottom: calc(-1 * var(--green-box-overlap, 302px));
        }

        .quote-decor {
          @apply pointer-events-none absolute inset-0 w-full h-full;

          .quote-svg {
            @apply absolute w-[43px] h-[43px] z-1 lg:w-[98px] lg:h-[98px];

            &.left {
              @apply bottom-[-12px] left-[-12px] lg:bottom-[-24px] lg:left-[-24px];
            }

            &.right {
              @apply top-[-12px] right-[-12px] lg:top-[-24px] lg:right-[-24px];
            }
          }
        }

        h3 {
          @apply relative z-2 text-white header-5 normal-case mb-4;
        }

        .bottom {
          @apply lg:flex lg:flex-col lg:gap-10;

          .description {
            :deep(*) {
              @apply relative z-2 text-white text-[16px] mb-4;
              @apply text-[14px];
            }
          }

          a {
            @apply w-fit mr-0 ml-auto flex flex-row gap-2 items-center;

            span {
              @apply transition-colors text-approachable underline text-[13px];
            }

            &:hover {
              span {
                @apply text-white;
              }

              svg {
                @apply fill-white;
              }

              svg {
                path {
                  @apply fill-white;
                }
              }
            }
          }
        }
      }
    }
  }

  .bottom-content {
    @apply hidden lg:block;

    .divider-container {
      @apply mt-0 mb-10;
    }

    h3 {
      @apply header-4 mb-6;
    }

    .posts-carousel {
      @apply relative pb-[50px];

      .splide {
        @apply relative w-full;

        .splide__track {
          @apply overflow-hidden;
        }

        .splide__slide {
          @apply pointer-events-auto min-w-0;
        }

        .post-card {
          @apply pointer-events-auto block w-full no-underline;

          .post-image {
            @apply relative w-full overflow-hidden;
            aspect-ratio: 16 / 9;

            > img {
              @apply h-full w-full object-cover object-center transition-transform duration-300 ease-out;
            }

            .post-player {
              @apply pointer-events-none absolute left-1/2 top-1/2 z-2 flex h-[52px] w-[52px] -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-white/30 transition-transform duration-300;
              background: linear-gradient(
                  0deg,
                  rgba(30, 107, 92, 0.06),
                  rgba(30, 107, 92, 0.06)
                ),
                linear-gradient(
                  270deg,
                  rgba(255, 255, 255, 0.2) 44.96%,
                  rgba(255, 255, 255, 0) 58.69%
                ),
                linear-gradient(
                  90deg,
                  rgba(255, 255, 255, 0.2) 11.27%,
                  rgba(255, 255, 255, 0) 23.4%
                ),
                rgba(255, 255, 255, 0.42);
              box-shadow: inset 0 2px 1px rgba(255, 255, 255, 0.15);
              -webkit-backdrop-filter: blur(20px);
              backdrop-filter: blur(20px);

              svg {
                @apply h-[20px] w-[18px] translate-x-[2px];
              }
            }
          }

          .post-title {
            @apply mt-4 text-[22px] font-normal leading-[1.2] text-humble;
          }

          &:hover,
          &:focus-visible {
            .post-image > img {
              @apply scale-105;
            }

            .post-player {
              @apply scale-110;
            }
          }
        }

        .splide__arrows {
          @apply absolute bottom-[-50px] right-0 flex items-center justify-end gap-5;

          .splide__arrow {
            @apply cursor-pointer border-0 bg-transparent p-0 transition-opacity duration-300 ease-out;

            .navigation-icon {
              @apply flex h-10 w-10 items-center justify-center rounded-full bg-progressive;

              svg {
                @apply h-5 w-5;

                path {
                  @apply fill-humble;
                }
              }
            }
          }
        }
      }
    }
  }
}

.featured-video-modal-fade {
  &-enter-active,
  &-leave-active {
    @apply transition-opacity duration-200;
  }

  &-enter-from,
  &-leave-to {
    @apply opacity-0;
  }
}
</style>

<style lang="scss">
.featured-video-modal {
  @apply fixed inset-0 z-[101] flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm md:p-8;

  .featured-video-modal-content {
    @apply relative w-full max-w-[1200px] overflow-hidden rounded-[12px] bg-black shadow-2xl lg:rounded-[27px];
    aspect-ratio: 16 / 9;

    iframe {
      @apply block h-full w-full border-0;
    }

    .featured-video-modal-close {
      @apply absolute right-3 top-3 z-2 flex h-11 w-11 cursor-pointer items-center justify-center rounded-full border border-white bg-humble/80 transition-colors hover:bg-white;

      span {
        @apply absolute h-[1px] w-5 bg-white transition-colors;

        &:first-child {
          @apply rotate-45;
        }

        &:last-child {
          @apply -rotate-45;
        }
      }

      &:hover span,
      &:focus-visible span {
        @apply bg-humble;
      }
    }
  }
}
</style>
